import { render, staticRenderFns } from "./NormalSearchNav330.vue?vue&type=template&id=2b2cb324&scoped=true"
import script from "./NormalSearchNav330.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav330.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2cb324",
  null
  
)

export default component.exports